var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.formatDateSimple(_vm.day.date)))]),_vm._l((_vm.day.notifications),function(notification,index){return _c('Notification',{key:index,attrs:{"notification":notification,"icon":_vm.getIcon(notification.eventType)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }